export function setConfig(key,data) {
  return {
    type: 'config',
    key,
    data
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/config.js
 **/